<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        《起名废急救指南》总目录
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月1日</Col>
      </Row>
      <p></p>
      <!-- <h3 style="text-align:left;">序言</h3> -->
      <p></p>
      <h5><router-link :to="{path: '/articalxu'}">序言</router-link></h5>
      <p></p>
      <!-- <p>为什么写这本书？取名过程中面临什么痛点？ </p> -->
      <h3>一、取名的思维过程</h3>
      <p></p>
      <h5><router-link :to="{path: '/artical2'}">1.1.1 取名的思维过程</router-link></h5>
      <!-- <p>在这个地方隐藏“遗传学”内容，吸引关注。</p> -->
      <p></p>
      <h3>二、基础知识</h3>
      <p>欲速则不达，为了避免急功近利造成严重内伤，打好基础很重要。</p>
      <h4>2.1 姓名相关知识 </h4>
      <p></p>
      <h5><router-link :to="{path: '/artical3'}">2.1.1 中华姓氏文化 </router-link></h5>
      <p>重点分析姓氏特点 为名字搭配做准备</p>
      <h5><router-link :to="{path: '/artical4'}">2.1.2 古人的名和字 </router-link></h5>
      <p></p>
      <h5><router-link :to="{path: '/artical5'}">2.1.3 法律法规 </router-link></h5>
      <p></p>
      <h4>2.2 语言学</h4>
      <p></p>
      <h5><router-link :to="{path: '/artical6'}">2.2.1 现代汉语基础知识 </router-link></h5>
      <p>汉字、构词法、语法</p>
      <h5>2.2.2 古代汉语基础知识</h5>
      <p></p>
      <h4>2.3 心理学</h4>
      <p></p>
      <h5>2.3.1 取名人的选择恐惧症</h5>
      <p></p>
      <h5>2.3.2 汉字中和心理相关的字</h5>
      <p></p>
      <h4>2.4 社会学</h4>
      <p>社会群体对取名的影响</p>
      <div style="display:none;"><h4 >2.5 遗传学（暂时隐藏 吸引关注）</h4>
      <p>孩子：你给我取这个名字，我不要面子的啊？</p></div>
      <h3>三、客观评价名字</h3>
      <p>欲速则不达，为了避免急功近利造成严重内伤，打好基础很重要。</p>
      <h4>3.1 音 </h4>
      <p></p>
      <h4>3.2 形</h4>
      <p></p>
      <h4>3.3 义 </h4>
      <p></p>
      <h4>3.4 结构 </h4>
      <p></p>
      <h4>3.5 风格 </h4>
      <p>港澳台用字特点</p>
      <p>日文名用字特点</p>
      <p>韩文名用字特点</p>
      <p>武侠用字特点</p>
      <p>言情用字特点</p>
      <p>古典</p>
      <p>民国</p>
      <p>现代</p>
      <h4>3.6 使用率和分布</h4>
      <p></p>
      <h4>3.7 知名度</h4>
      <p>取名中让你躺枪的现象</p>
      <h4>3.8 佳名赏析</h4>
      <p></p>
      <h3>四、取名技巧</h3>
      <p></p>
      <h4>4.1 断章取义 </h4>
      <p></p>
      <h5>4.1.1 借用《诗经》取名 </h5>
      <p></p>
      <h5>4.1.2 借用《楚辞》取名 </h5>
      <p></p>
      <h5>4.1.3 借用《论语》取名 </h5>
      <p></p>
      <h5>4.1.4 借用《周易》取名</h5>
      <p></p>
      <h5>4.1.5 借用《孟子》取名 </h5>
      <p></p>
      <h5>4.1.6 借用《大学》取名</h5>
      <p></p>
      <h5>4.1.7 借用《中庸》取名</h5>
      <p></p>
      <h5>4.1.8 借用《荀子》取名</h5>
      <p></p>
      <h5>4.1.9 借用《庄子》取名</h5>
      <p></p>
      <h5>4.1.10 借用《道德经》取名</h5>
      <p></p>
      <h5>4.1.11 借用《唐诗》取名</h5>
      <p></p>
      <h5>4.1.12 借用《宋词》取名</h5>
      <p></p>
      <h5>4.1.13 借用曲、歌、赋取名</h5>
      <p></p>
      <h5>4.1.14 借用对联取名</h5>
      <p></p>
      <h5>4.1.15 借用成语典故取名</h5>
      <p></p>
      <h5>4.1.16 借用名言警句取名</h5>
      <p></p>
      <h4>4.2 期望祝愿</h4>
      <p></p>
      <h4>4.3 借物喻人</h4>
      <p></p>
      <h4>4.4 文字游戏</h4>
      <p></p>
      <h4>4.5 引入虚字</h4>
      <p></p>
      <h4>4.6 文饰修辞</h4>
      <p></p>
      <h4>4.7 姓氏联动</h4>
      <p></p>
      <h4>4.8 纪念事件</h4>
      <p></p>
      <h3>五、细分取名场景</h3>
      <p></p>
      <h5>姓氏取名</h5>
      <p></p>
      <h5>双胞胎取名</h5>
      <p></p>
      <h5>兄弟姐妹取名</h5>
      <p></p>
      <h5>四字名问题</h5>
      <p></p>
      <h5>字辈</h5>
      <p></p>
      <h5>小名</h5>
      <p></p>
      <h5>英文名</h5>
      <p></p>
      <h5>笔名</h5>
      <p></p>
      <h5>艺名</h5>
      <p></p>
      <h5>外号</h5>
      <p></p>
      <h5>游戏名</h5>
      <p></p>
      <h5>宠物名</h5>
      <p></p>
      <h3>六、生肖和名字有关系吗？</h3>
      <p></p>
      <h3>七、取名参考工具书</h3>
      <p></p>
      <h3>八、取名工具</h3>
      <p></p>
      <h4>8.1、“姓名图谱”</h4>
      <p>使用工具简化取名过程</p>
      <h4>8.2 热榜</h4>
      <p></p>
      <h5>热字</h5>
      <p></p>
      <h5>热名</h5>
      <p></p>
      <h4 style="color: #ddd;">参考资料</h4>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
       text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
